import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { SpecraPageHeader, SpecraTabBar } from '@mono/ui-components';
import { Testids } from '@mono/ui-selectors';
import { useState } from 'react';
import { CPARSScoresTab } from './CPARSScoresTab';
import { QASPScoresTab } from './QASPScoresTab';
export function QualityTab({ programId }) {
    const [active, setActive] = useState('cpars');
    // Only the active panel mounts — the same lifecycle Radix TabsContent had, so
    // each sub-tab's queries fire on first visit rather than all up front.
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(SpecraPageHeader, {
                className: "mb-4",
                title: "Quality",
                description: "QASP self-assessments and CPARS evaluations — drives the Satisfaction KPI."
            }),
            /*#__PURE__*/ _jsx(SpecraTabBar, {
                label: "Quality sections",
                value: active,
                onValueChange: setActive,
                options: [
                    {
                        value: 'cpars',
                        label: 'CPARS',
                        testId: Testids.deliveryQuality.subTabCpars
                    },
                    {
                        value: 'qasp',
                        label: 'QASP',
                        testId: Testids.deliveryQuality.subTabQasp
                    }
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "mt-6",
                children: active === 'cpars' ? /*#__PURE__*/ _jsx(CPARSScoresTab, {
                    programId: programId
                }) : /*#__PURE__*/ _jsx(QASPScoresTab, {
                    programId: programId
                })
            })
        ]
    });
}
